/*
  Mije Seoul — PDP behaviour (Screen 3).
  Variant switching via colour swatches, mobile gallery index, cart adds
  (single + "Add the look"), live bundle totals, recommendations hydration.
  No frameworks — plain DOM, one IIFE per concern.
*/

/*
  Pre-order line item property, shared by both cart-add paths in this file.
  Liquid renders the hidden input only for a pre-order piece, so the presence
  of the input IS the flag — the script never decides what is on pre-order.
  Returns null (not {}) when there is nothing to send, because /cart/add.js
  treats an empty properties object as a distinct line from no properties.
  Only ever applied to THIS product's variant: the "Add the look" companions
  are other products with their own state.
*/
window.MijePreorder = {
  props: function () {
    var input = document.querySelector('[data-preorder-prop]');
    /* disabled = the SELECTED variant is not a pre-order path (in stock, or
       not buyable) — no promise rides on that line */
    if (!input || input.disabled || !input.value) return null;
    return { 'Pre-order': input.value };
  },
};

(function () {
  'use strict';

  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var productJson = root.querySelector('[data-pdp-json]');
  var product = productJson ? JSON.parse(productJson.textContent) : null;

  var moneyFormatter = new Intl.NumberFormat('en-SG', {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SGD',
  });

  function formatMoney(cents) {
    // display-currency aware (mije-currency.js); falls back to SGD
    if (window.MijeCurrency) return window.MijeCurrency.format(cents);
    return moneyFormatter.format(cents / 100);
  }

  function updateBagCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.mj-header__count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------ variant switching */

  function currentVariantId() {
    var input = document.querySelector('[data-variant-id]');
    return input ? Number(input.value) : null;
  }

  /* Sold out <=> quantity <= 0. Pre-order = the product is ARMED (the button
     carries data-preorder-label, which Liquid only emits when mije.is_preorder
     is on AND mije.preorder_ship_date is in the future) AND the variant is at
     <= 0 AND still sells (available at <= 0 means "continue selling"). Same
     test as the Liquid render — a mixed product flips per selection. */
  function isArmed() {
    var btn = document.querySelector('[data-add-to-bag]');
    return !!(btn && btn.dataset.preorderLabel);
  }

  function inStock(variant) {
    return !!(variant && variant.inventory_quantity > 0);
  }

  function isPreorderVariant(variant) {
    return !!(
      variant &&
      !inStock(variant) &&
      variant.available &&
      isArmed()
    );
  }

  function isBuyable(variant) {
    return inStock(variant) || isPreorderVariant(variant);
  }

  function setBuyState(available, label, preorder) {
    document.querySelectorAll('[data-add-to-bag]').forEach(function (btn) {
      btn.disabled = !available;
      btn.textContent = available
        ? (preorder && btn.dataset.preorderLabel) || 'Add to bag'
        : label;
    });
    var prop = document.querySelector('[data-preorder-prop]');
    if (prop) prop.disabled = !preorder;
    /* PREORDER10 nudge, ship line + PDP note follow the selection and leave
       the layout entirely on an in-stock cut (nothing reserved); inline display, never the
       hidden attribute (flow display rules outrank it) */
    ['[data-preorder-nudge="pdp"]', '[data-preorder-line]', '[data-preorder-pdp-note]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.display = preorder ? '' : 'none';
      });
    });
  }

  function applyVariant(variant, skipScroll) {
    if (!variant) {
      // A combination the product does not sell. Blanking the hidden id as
      // well as disabling the button means there is no path — not even a
      // stray script or an enter key on the form — that adds the previously
      // resolved variant under a selection the shopper never made.
      document.querySelectorAll('[data-variant-id]').forEach(function (el) {
        el.value = '';
      });
      var gone = document.querySelector('[data-stock-note]');
      if (gone) gone.textContent = '';
      setBuyState(false, 'Sold out', false);
      return;
    }

    document.querySelectorAll('[data-price]').forEach(function (el) {
      el.dataset.base = variant.price;
      el.textContent = formatMoney(variant.price);
    });

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    document.querySelectorAll('[data-compare-at]').forEach(function (el) {
      el.hidden = !onSale;
      if (onSale) {
        el.dataset.base = variant.compare_at_price;
        el.textContent = formatMoney(variant.compare_at_price);
      }
    });
    document.querySelectorAll('[data-sale-badge]').forEach(function (el) {
      el.hidden = !onSale;
    });


    var stockNote = document.querySelector('[data-stock-note]');
    if (stockNote && typeof variant.inventory_quantity === 'number') {
      var qty = variant.inventory_quantity;
      var managed = variant.inventory_management;
      // wording comes from Liquid — "in this colour" is only true on a
      // colour-only product (snippets/mije-buy-measurements.liquid)
      var suffix = stockNote.dataset.stockSuffix || ' left';
      stockNote.textContent = variant.available && managed && qty > 0 && qty <= 9 ? qty + suffix : '';
    }

    document.querySelectorAll('[data-variant-id]').forEach(function (el) {
      el.value = variant.id;
    });

    // Sold out <=> quantity <= 0; a pre-order button keeps its label across
    // variant switches — the flag is on the product, not the variant. Without
    // this the first option click would silently turn "Pre-order" back into
    // "Add to bag".
    setBuyState(isBuyable(variant), 'Sold out', isPreorderVariant(variant));

    var barSize = document.querySelector('[data-bar-size]');
    if (barSize && barSize.dataset.barSizeIndex) {
      var barIdx = Number(barSize.dataset.barSizeIndex);
      if (variant.options[barIdx]) barSize.textContent = variant.options[barIdx];
    }

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    // scroll the gallery to the variant's media, if it has its own
    if (variant.featured_media && !skipScroll) {
      var cell = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (cell) cell.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  /* ------------------------------------------------ option → variant */

  /*
    Every option group on the page is a peer. The selection is the full tuple
    of option values and the variant is whatever matches ALL of them — the old
    code matched on ONE option index, which is why adding a second option
    (Classic Mini Dress → Size) left the page stuck on the colour's first
    variant no matter what the shopper picked.

    Nothing here knows the name of an option. A group is anything carrying
    [data-option-input] with its option index, so a colour swatch row and a
    size button row go through exactly the same path.
  */
  var optionGroups = [].slice.call(root.querySelectorAll('[data-option-input]'));

  function currentSelection() {
    var selection = [];
    optionGroups.forEach(function (group) {
      var idx = Number(group.dataset.optionIndex || 0);
      var on = group.querySelector('[data-opt-btn][aria-pressed="true"]');
      selection[idx] = on ? on.dataset.value : null;
    });
    return selection;
  }

  function variantFor(selection) {
    if (!product) return null;
    var found = product.variants.filter(function (v) {
      return selection.every(function (value, i) {
        return value === null || v.options[i] === value;
      });
    });
    return found.length ? found[0] : null;
  }

  /* is there a BUYABLE variant carrying `value` at `idx` while every other
     option keeps its current selection? */
  function availableWith(selection, idx, value) {
    if (!product) return true;
    return product.variants.some(function (v) {
      if (!isBuyable(v) || v.options[idx] !== value) return false;
      return selection.every(function (chosen, i) {
        return i === idx || chosen === null || v.options[i] === chosen;
      });
    });
  }

  function paintOptions(selection) {
    optionGroups.forEach(function (group) {
      var idx = Number(group.dataset.optionIndex || 0);
      group.querySelectorAll('[data-opt-btn]').forEach(function (btn) {
        var isOn = btn.dataset.value === selection[idx];
        btn.classList.toggle('is-selected', isOn);
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');

        var ok = availableWith(selection, idx, btn.dataset.value);
        btn.classList.toggle('is-unavailable', !ok);
        // data-unavailable, not aria-disabled: the value stays selectable so
        // the shopper can reach Notify me (assets/mije-wishlist.js), and the
        // sold-out state rides in the accessible name instead
        var name = (btn.getAttribute('aria-label') || '').replace(/ — sold out$/, '');
        if (ok) {
          btn.removeAttribute('data-unavailable');
        } else {
          btn.setAttribute('data-unavailable', 'true');
          name += ' — sold out';
        }
        if (btn.getAttribute('aria-label') !== null) btn.setAttribute('aria-label', name);
      });

      var block = group.closest('[data-option-block]');
      var label = block && block.querySelector('[data-option-value]');
      if (label && selection[idx]) label.textContent = selection[idx];
    });

    paintMeasurements(selection);
  }

  /*
    The above-fold measurement strip follows the SELECTED SIZE.

    Where the metafield carries two columns whose labels line up with the size
    values ("Original Size" / "Mini Size" against ["Original","Mini"]), the strip
    used to show column one whatever was picked — so a shopper on Mini Size read
    Original's numbers. Wrong data, not just a stale label.

    Both values ride on each cell as data-v1/data-v2 from Liquid, so this only
    chooses between them; it never re-derives or re-formats a measurement, and
    the unit rule stays in one place (snippets/mije-meas-value.liquid).

    Bails out harmlessly for everything else: a product with no size option, no
    columns, or a single column returns before touching the DOM. An unmatched
    size falls back to the first column rather than erroring.
  */
  function normaliseSizeWord(s) {
    return String(s || '').toLowerCase().trim().replace(/\s+size$/, '').trim();
  }

  function paintMeasurements(selection) {
    var strip = document.querySelector('[data-meas-strip]');
    if (!strip) return;

    var idx = Number(strip.dataset.sizeOptionIndex);
    if (!(idx >= 0)) return;

    var cols = (strip.dataset.measCols || '').split('|').filter(Boolean);
    if (cols.length < 2) return;

    var want = normaliseSizeWord(selection[idx]);
    var col = 1;
    for (var i = 0; i < cols.length; i++) {
      if (normaliseSizeWord(cols[i]) === want) {
        col = i + 1;
        break;
      }
    }

    strip.dataset.measSelected = String(col);
    strip.querySelectorAll('.mj-pdp__strip-cell').forEach(function (cell) {
      var v = cell.querySelector('[data-meas-v]');
      if (!v) return;
      var next = col === 2 ? cell.dataset.v2 : cell.dataset.v1;
      v.textContent = next || '—';
    });
  }

  if (optionGroups.length && product) {
    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-opt-btn]');
        if (!btn) return;
        var idx = Number(group.dataset.optionIndex || 0);
        var selection = currentSelection();
        if (selection[idx] === btn.dataset.value) return;
        selection[idx] = btn.dataset.value;
        // paint first: an unbuyable combination must still show what the
        // shopper picked, with Add to bag turning into a disabled "Sold out"
        paintOptions(selection);
        applyVariant(variantFor(selection));
      });
    });
  }

  /* ----------------------------------------------------------- add to bag */

  function addItems(items, button, doneLabel) {
    var original = button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.addingLabel || 'Adding…';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        button.textContent = doneLabel || 'Added ✓';
        updateBagCount();
      })
      .catch(function () {
        button.textContent = 'Try again';
      })
      .then(function () {
        setTimeout(function () {
          button.disabled = false;
          button.textContent = original;
        }, 1800);
      });
  }

  document.querySelectorAll('[data-add-to-bag]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = currentVariantId();
      if (!id) return;
      var item = { id: id, quantity: 1 };
      var props = window.MijePreorder.props();
      if (props) item.properties = props;
      addItems([item], btn);
    });
  });

  /* re-render variant-driven amounts when the display currency changes */
  window.addEventListener('mije:currency', function () {
    if (!product) return;
    var id = currentVariantId();
    var v = product.variants.find(function (x) { return x.id === id; });
    if (v) applyVariant(v, true);
  });

  /* ------------------------------------------------------- mobile gallery */

  var gallery = root.querySelector('[data-pdp-gallery]');
  var currentEl = root.querySelector('[data-gallery-current]');
  if (gallery && currentEl) {
    gallery.addEventListener(
      'scroll',
      function () {
        var cells = gallery.querySelectorAll('.mj-pdp__cell');
        if (!cells.length) return;
        var index = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
        currentEl.textContent = Math.min(Math.max(index, 1), cells.length);
      },
      { passive: true }
    );
  }
})();

/* --------------------------------------------------------- wear it together */

(function () {
  'use strict';

  var panel = document.querySelector('[data-wear-panel]');
  if (!panel) return;

  var totalEl = panel.querySelector('[data-wear-total]');
  var wasEl = panel.querySelector('[data-wear-was]');
  var saveEl = panel.querySelector('[data-wear-save]');
  var saveAmtEl = panel.querySelector('[data-wear-save-amt]');
  var savePctEl = panel.querySelector('[data-wear-save-pct]');
  var hintEl = panel.querySelector('[data-wear-hint]');
  var countEl = panel.querySelector('[data-wear-count]');
  var addBtn = panel.querySelector('[data-wear-add]');
  var lockedEl = panel.querySelector('[data-wear-locked]');
  var baseCents = Number(totalEl.dataset.baseCents || 0);

  /*
    Covered bundles that can be completed from this panel. Emitted by
    mije-pdp-wear.liquid only where such a bundle exists, so on almost every
    product this is an empty list and everything below is inert.
  */
  var bundles = [];
  var bundleTag = panel.querySelector('[data-wear-bundles]');
  if (bundleTag) {
    try {
      bundles = JSON.parse(bundleTag.textContent) || [];
    } catch (e) {
      bundles = [];
    }
  }

  var moneyFormatter = new Intl.NumberFormat('en-SG', {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SGD',
  });

  function money(cents) {
    return window.MijeCurrency ? window.MijeCurrency.format(cents) : moneyFormatter.format(cents / 100);
  }

  function recalc() {
    var cents = baseCents;
    var count = 1; // the current product is locked in

    /* lines carry their PRODUCT id because bundles are defined over products,
       not variants — the locked-in product is always one of them */
    var lines = [];
    if (lockedEl && lockedEl.dataset.productId) {
      lines.push({ product: Number(lockedEl.dataset.productId), price: baseCents });
    }
    panel.querySelectorAll('[data-wear-item]:checked').forEach(function (box) {
      var price = Number(box.dataset.priceCents || 0);
      cents += price;
      count += 1;
      if (box.dataset.productId) lines.push({ product: Number(box.dataset.productId), price: price });
    });

    /*
      TRUTH RULE, same as the shop-the-look card: the discount function needs
      EVERY product of a bundle present before it takes anything off, so a
      bundle only counts here once it is fully selected.

      Rounding is PER LINE because the function discounts each cart line
      separately. Where a line belongs to two qualifying bundles it takes the
      single better percentage, never both — which is what the function does.
    */
    var selected = lines.map(function (l) { return l.product; });
    var qualifying = bundles.filter(function (b) {
      return b.products.every(function (pid) { return selected.indexOf(pid) !== -1; });
    });

    var save = 0;
    var bestPct = 0;
    qualifying.forEach(function (b) { if (b.pct > bestPct) bestPct = b.pct; });
    lines.forEach(function (line) {
      var pct = 0;
      qualifying.forEach(function (b) {
        if (b.products.indexOf(line.product) !== -1 && b.pct > pct) pct = b.pct;
      });
      if (pct > 0) save += Math.round((line.price * pct) / 100);
    });

    var total = cents - save;
    totalEl.dataset.base = total;
    totalEl.classList.add('mj-money');
    totalEl.textContent = money(total);
    countEl.textContent = count + (count === 1 ? ' piece selected' : ' pieces selected');

    /* struck sum and savings line move together — never one without the other */
    if (save > 0) {
      if (wasEl) {
        wasEl.hidden = false;
        wasEl.dataset.base = cents;
        wasEl.textContent = money(cents);
      }
      if (saveEl) {
        saveEl.hidden = false;
        saveAmtEl.dataset.base = save;
        saveAmtEl.textContent = money(save);
        savePctEl.textContent = String(Math.round(bestPct));
      }
    } else {
      if (wasEl) wasEl.hidden = true;
      if (saveEl) saveEl.hidden = true;
    }

    /* the condition, stated only where a discount is actually reachable */
    if (hintEl) {
      if (bundles.length) {
        var biggest = bundles.reduce(function (a, b) { return b.products.length > a.products.length ? b : a; });
        hintEl.textContent =
          Math.round(biggest.pct) + '% off applies when all ' + biggest.products.length + ' pieces are added';
        hintEl.hidden = false;
      } else {
        hintEl.hidden = true;
      }
    }
    panel.classList.toggle('is-discounted', save > 0);
  }

  panel.addEventListener('change', recalc);
  recalc();

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      // the current product's variant + every checked companion
      var items = [];
      var currentInput = document.querySelector('[data-variant-id]');
      if (currentInput) {
        var current = { id: Number(currentInput.value), quantity: 1 };
        var props = window.MijePreorder.props();
        if (props) current.properties = props;
        items.push(current);
      }
      panel.querySelectorAll('[data-wear-item]:checked').forEach(function (box) {
        items.push({ id: Number(box.dataset.variantId), quantity: 1 });
      });
      if (!items.length) return;

      var original = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = addBtn.dataset.addingLabel || 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          addBtn.textContent = 'Added ✓';
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('.mj-header__count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            })
            .catch(function () {});
        })
        .catch(function () {
          addBtn.textContent = 'Try again';
        })
        .then(function () {
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = original;
          }, 1800);
        });
    });
  }
})();

/* --------------------------------------------------------- recommendations */

(function () {
  'use strict';

  var wrap = document.querySelector('[data-recommendations]');
  if (!wrap || !wrap.dataset.url) return;

  fetch(wrap.dataset.url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('.mj-card')) {
        wrap.innerHTML = fresh.innerHTML;
      }
    })
    .catch(function () {});
})();
